function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ProfileIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C2.3 0 1 1.4 1 3v26c0 1.6 1.3 3 3 3h24c1.6 0 3-1.4 3-3V3c0-1.6-1.4-3-3-3zm-1 28H5V4h22v24zM9 18h14v2H9v-2zm0 4h14v2H9v-2zm2-13c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm5 3h-4c-1.6 0-3 .9-3 2v2h10v-2c0-1.1-1.4-2-3-2z"
  }));
};
export default ProfileIcon;